import { render, staticRenderFns } from "./DocumentDetails.vue?vue&type=template&id=422670b4&"
import script from "./DocumentDetails.vue?vue&type=script&lang=js&"
export * from "./DocumentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports